import { Directive, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationContextService, ConfirmationModalComponent, Fb, IPaginationRequestBaseModel, IPaginationResponseModel, RolePermissionService, UtilitiesService } from "lib-core-shared";
import { BehaviorSubject, Observable, of, Subscription } from "rxjs";
import { MESSAGES } from "../constants";
import { TabItem } from "../lib-tabs/models/tab-item-model";
import { PaginationModel } from "../models/pagination-model";
import { ComponentBaseDirective } from "./component.directive";

@Directive({
    selector: 'app-page-base'
})
/// TODO: Put PUT type in.
export class MultiTypePageBaseDirective<GetType, SaveType> extends ComponentBaseDirective {
    public fb: Fb | undefined = { text: 'LDGILL', status: 'text-info' };
    public disableSave: boolean = true;
    @Input() broadCastSubmssion$ = new BehaviorSubject<boolean> (false);
    @Output() public submittedEvent: EventEmitter<boolean> = new EventEmitter<boolean> (false);
    @Output() public closeEntityEmitter = new EventEmitter<SaveType>();
    public paginationDetails: IPaginationRequestBaseModel;
    public subscription: Subscription | undefined;
    public paginationDetails$ :BehaviorSubject<PaginationModel>;
    public totalTranslation: number = 0;
    public results:Observable<GetType[]>  | undefined;
    public result: Observable<GetType> | undefined;
    public messageLoadingRetrievalDescription: string = '';
    public messageLoadingSubmissionDescription: string = '';
    public messageErrorLoading: string = ';'
    public savedSuccessfullyMessage!: string;
    public errorSavingMessage!: string;
    public newId!: SaveType;

    @Input() public isNew: boolean = true;
    @Input() public tab!: TabItem;
    @Input() public id: string = '';
    @Input() resultReponse$: Observable<IPaginationResponseModel<GetType>> | undefined;
    @Input() response$: Observable<GetType> | undefined;
    @Input() delete$!: Observable<boolean>;
    @Input() save$!: Observable<SaveType>;
    @Input() update$!: Observable<SaveType>;
    @Output() cancelEmitter = new EventEmitter<boolean>();
  
    constructor(
      public activatedRoute: ActivatedRoute,
      public router: Router,
      public modalService: NgbModal,
      public utilitiesService: UtilitiesService,
      public roleService: RolePermissionService,
      public applicationContext: ApplicationContextService
    ) {
      super(activatedRoute, router, roleService, applicationContext);
      this.paginationDetails = {
        currentpage: 1,
        rowsperpage: 10,
      }  as PaginationModel;
      this.paginationDetails$ = new BehaviorSubject<PaginationModel>(this.paginationDetails);
      this.utilitiesService.unSavedChangesConfirm = false;
  }
  public ngbModalOption: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    size: 'lg'
  }

  public requestPageData(page: number) {
    if (this.utilitiesService.unSavedChangesConfirm) {
      const modalRef = this.modalService.open(ConfirmationModalComponent);
      modalRef.componentInstance.title = 'Confirmation';
      modalRef.componentInstance.body = MESSAGES.CONFIRMATION_UNSAVED_CHANGES;
      modalRef.componentInstance.confirmEmitter.subscribe((outcome: boolean) => {
        modalRef.close();
        if (outcome && this.paginationDetails) {
          this.paginationDetails.currentpage = page;
          this.getData();
        }
      });
    } else {
      if (this.paginationDetails) {
        this.paginationDetails.currentpage = page;
      }
      this.getData();
    }
  }

  public getDetail() {
    if (!this.silentLoading) {
      this.isBusy = true;
    }
    if (this.response$) {
      this.subscription =  this.response$.subscribe((response: GetType) => {
        this.result = of(response);
        this.isBusy = false;
        this.broadCastSubmssion$ = new BehaviorSubject<boolean> (true);
        this.submittedEvent.emit(true);
      }, e => { 
        this.isBusy = false;
        if (e.status !== 404) {
          this.reportError(e, this.messageErrorLoading);
        }
        this.submittedEvent.emit(false);
      });
    }
  }

  public getData() {
    if (!this.silentLoading) {
      this.isBusy = true;
    }
    if (this.resultReponse$) {
      const that = this;
      this.subscription =  this.resultReponse$.subscribe((response: IPaginationResponseModel<GetType>) => {
        this.paginationDetails.totalPages = response.total ? Math.ceil(response.total / 10) : 0;
        this.totalTranslation = response?.total ? response?.total : 0;
        that.results = response?.data?.length > 100 ? of(response.data.slice(0, 100)): response?.data ? of(response.data) : of([]);
        this.isBusy = false;
        this.paginationDetails$.next(this.paginationDetails);
        this.broadCastSubmssion$.next(true);
      }, e => { 
        this.isBusy = false;
        if (e.status !== 404) {
          this.reportError(e, this.messageErrorLoading);
        }
      });
    }
  }

  public updateData() {
    this.isBusy = true;
    this.update$.subscribe(x =>
      {
        this.isBusy = false;
        this.utilitiesService.unSavedChangesConfirm = false;
        this.silentLoading = true;
        this.newId = x;
        this.getData();
        // const modalRef = this.modalService.open(ModalComponent);
        // modalRef.componentInstance.title = 'Success';
        // modalRef.componentInstance.p = this.savedSuccessfullyMessage;
        // modalRef.result.then(() => {
          this.silentLoading = false;
          this.broadCastSubmssion$.next(true);
          this.utilitiesService.updatePageSubject.next(null);
          this.closeEntityEmitter.emit(x);
          this.closeEmitter.emit(true);
       //  });
      } ,
      e => {
        this.broadCastSubmssion$.next(false);
        this.isBusy = false;
        this.silentLoading = false;
        if (e.status !== '404') {
          this.reportError(e, this.errorSavingMessage);
        }
      });
  }

  public deleteData() {
    this.isBusy = true;
    this.delete$.subscribe(x =>
      {
        this.isBusy = false;
        this.utilitiesService.unSavedChangesConfirm = false;
        this.silentLoading = true;
        this.getData();
        // const modalRef = this.modalService.open(ModalComponent);
        // modalRef.componentInstance.title = 'Success';
        // modalRef.componentInstance.p = this.savedSuccessfullyMessage;
        //  modalRef.result.then(() => this.silentLoading = false);
        this.silentLoading = false
        this.broadCastSubmssion$.next(true);
        this.closeEmitter.emit(true);
      } ,
      e => {
        this.isBusy = false;
        if (e.status !== 404) {
          this.reportError(e, this.messageErrorLoading);
        } else {
          this.results = of([]);
          this.totalTranslation = 0;
          this.broadCastSubmssion$.next(true);
          this.paginationDetails.totalPages = 0;
        }
      });
  }

  public saveData() {
    this.isBusy = true;
    this.save$.subscribe(x =>
      {
        this.isBusy = false;
        this.utilitiesService.unSavedChangesConfirm = false;
        this.silentLoading = true;
        this.newId = x;
        this.getData();
        // const modalRef = this.modalService.open(ModalComponent);
        // modalRef.componentInstance.title = 'Success';
        // modalRef.componentInstance.p = this.savedSuccessfullyMessage;
        // modalRef.result.then(() => {
          this.silentLoading = false;
          this.broadCastSubmssion$.next(true);
          this.closeEntityEmitter.emit(x);
          this.closeEmitter.emit(true);
       // });
      } ,
      e => {
        this.isBusy = false;
        this.silentLoading = false;
        if (e.status !== 404) {
          this.reportError(e, this.errorSavingMessage);
        }
        this.broadCastSubmssion$.next(false);
      });
  }

  public closeModal() {
    this.modalService.dismissAll();
  }
}